import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, IconButton, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { grey } from "@mui/material/colors";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { storeDepositMilestones } from "components/EboStoreV4/data";

const SecurityDepositBreakdown = ({ security_deposit, state, setState }) => {
	// State for grid rows
	const [rows, setRows] = useState([{ sl_no: 1, remarks: "", deposit_value: "", milestone: "", deposit_type: "SECURITY_DEPOSIT" }]);

	// Function to add a new row
	const handleAddRow = () => {
		const newRow = {
			sl_no: rows.length + 1,
			deposit_type: "SECURITY_DEPOSIT",
			remarks: "",
			deposit_value: "",
			milestone: "",
		};
		setRows((prevRows) => [...prevRows, newRow]);
	};

	console.log("qwertyuiop", rows);
	// Using processRowUpdate to update rows efficiently
	const processRowUpdate = (newRow, oldRow) => {
		const updatedRows = rows.map((row) => {
			if (row.sl_no === newRow.sl_no) return newRow;
			else return row;
		});
		setRows(updatedRows);
		setState((prevState) => ({
			...prevState,
			deposit_details: updatedRows,
		}));
		return newRow;
	};

	// function to delete a row.
	const handleDeleteRow = (sl_no) => {
		const updatedRows = rows
			.filter((row) => row.sl_no !== sl_no)
			.map((row, index) => ({
				...row,
				sl_no: index + 1, // Re-index rows
			}));
		setRows(updatedRows);
		setState((prevState) => ({
			...prevState,
			deposit_details: updatedRows,
		}));
	};

	// Define columns
	const columns = [
		{
			field: "sl_no",
			headerName: "Sl No",
			width: 100,
			editable: false,
		},
		{
			field: "remarks",
			headerName: "Remarks",
			flex: 1,
			editable: true,
		},
		{
			field: "deposit_type",
			headerName: "Type",
			flex: 1,
			editable: false,
		},
		{
			field: "milestone",
			headerName: "Milestone",
			width: 150,
			editable: true,
			// renderCell: (params) => <MilestoneEditCell {...params} />,
			type: "singleSelect",
			valueOptions: storeDepositMilestones.map((val) => ({ label: val?.label, value: val?.value })),
		},
		{
			field: "deposit_value",
			headerName: "Amount",
			width: 150,
			editable: true,
		},
		{
			field: "actions",
			headerName: "",
			width: 100,
			renderCell: (params) => {
				// Only show Add button in the last row
				const isLastRow = params.id === rows.length;
				return (
					isLastRow && (
						<Box width={120}>
							<Tooltip title="Add Row">
								<IconButton onClick={handleAddRow}>
									<AddCircleOutlineIcon />
								</IconButton>
							</Tooltip>
							<Tooltip title="Delete Row">
								<IconButton onClick={() => handleDeleteRow(params.row.sl_no)} disabled={params.id === 1}>
									<DeleteOutlineOutlinedIcon />
								</IconButton>
							</Tooltip>
						</Box>
					)
				);
			},
		},
	];

	return (
		<Box mt={2}>
			<Typography variant="button" width="100%">
				SECURITY DEPOSIT BREAKDOWN
			</Typography>
			<Box sx={{ display: "flex", width: "100%" }}>
				<DataGrid
					sx={{
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
					}}
					columnHeaderHeight={35}
					rowHeight={40}
					rows={rows}
					columns={columns}
					getRowId={(row) => row.sl_no}
					processRowUpdate={processRowUpdate}
					disableSelectionOnClick
					hideFooter
				/>
			</Box>
		</Box>
	);
};

export default SecurityDepositBreakdown;
